import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import PopularMatch from '../popular-match/PopularMatch.jsx';

const messages = defineMessages({
    title: {
        id: 'popular.title',
        defaultMessage: 'Популярные ставки'
    },
    win1: {
        id: 'popular.win1',
        defaultMessage: 'П1'
    },
    draw: {
        id: 'popular.draw',
        defaultMessage: 'Х'
    },
    win2: {
        id: 'popular.win2',
        defaultMessage: 'П2'
    }
});

class Popular extends React.Component {
    static propTypes = {
        matches: React.PropTypes.object,
        gridLocalization: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

    static renderMatch(match, gridLocalization) {
        return (
            <PopularMatch key={match.get('id')} match={match} gridLocalization={gridLocalization} />
        );
    }

    render() {
        const {gridLocalization} = this.props;
        const matches = this.props.matches.valueSeq().toList();

        return (
            <div className="popular">
                <div className="table popular--table main-heading">
                    <div className="row">
                        <span className="cell main">
                            <FormattedMessage {...messages.title}>
                                {(title) => (<h1 style={{display: 'inline-block'}}>{title}</h1>)}
                            </FormattedMessage>
                        </span>
                        <span className="cell cell-outcomes">
                            <FormattedMessage {...messages.win1} />
                        </span>
                        <span className="cell cell-outcomes">
                            <FormattedMessage {...messages.draw} />
                        </span>
                        <span className="cell cell-outcomes">
                            <FormattedMessage {...messages.win2} />
                        </span>
                    </div>
                </div>

                <div className="event popular--event">
                    <div className="event-header popular--event-header">
                        {matches.map(match => Popular.renderMatch(match, gridLocalization))}
                    </div>
                </div>
            </div>
        );
    }
}

function select(state) {
    const matches = state.application.getIn(['popularMatches', 'matches']);

    return {
        matches
    };
}

export default connect(select)(Popular);



// WEBPACK FOOTER //
// ./js/sport-betting/components/main-page/banners/popular/Popular.jsx